import { render, staticRenderFns } from "./TableRiskAppraisalEp2_3x3.vue?vue&type=template&id=f5faae3c&scoped=true"
import script from "./TableRiskAppraisalEp2_3x3.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisalEp2_3x3.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisalEp2_3x3.vue?vue&type=style&index=0&id=f5faae3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5faae3c",
  null
  
)

export default component.exports